
const SET_LISTRECORD = (state, payload) => {
  state.list = payload
}

const SETCREATERECORD = (state, payload) => {
  state.createRecord = payload
}

export default {
  SET_LISTRECORD,
  SETCREATERECORD
}



// WEBPACK FOOTER //
// ./src/store/modules/medical-record/mutations.js